<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar v-if="this.nonTradeData.tranMode !== 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-plus</v-icon>
              <v-toolbar-title>Create Non-Trade</v-toolbar-title>
            </v-toolbar>
            <v-toolbar v-if="this.nonTradeData.tranMode === 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-pencil</v-icon>
              <v-toolbar-title>Edit Non-Trade</v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabNav">
              <v-tab @click.native="doValidateMandatory(0)">Main</v-tab>
              <v-tab @click.native="doValidateMandatory(1)">Optional</v-tab>
              <v-tab @click.native="doValidateMandatory(2)" :disabled="this.nonTradeForm.transactionType === 'Z'">Payment Method</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabNav" touchless>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory" eager>
                <form data-vv-scope="MainMandatoryForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="branches"
                                v-model="nonTradeForm.branch"
                                :label="nonTradeLabel.branch"
                                item-text="label"
                                item-value="value"
                                data-vv-name="nonTradeForm.branch"
                                :data-vv-as="nonTradeLabel.branch"
                                :error-messages="errors.collect('nonTradeForm.branch')"
                                clearable
                                v-validate="'required'"
                                @change="doGetDefaultBankNo()"
                                :disabled="this.nonTradeData.tranMode === 'R'"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md3 xs12>
                              <v-radio-group
                                v-model="nonTradeForm.transactionType"
                                row
                                :mandatory="true"
                                @change="doRcptPayt($event)"
                                :disabled="nonTradeData.tranMode === 'R'"
                              >
                                <v-radio label="Receipt" value="Y"></v-radio>
                                <v-radio label="Payment" value="Z"></v-radio>
                              </v-radio-group>
                            </v-flex>
                            <v-flex md3 xs12> </v-flex>
                            <v-flex md4 xs12>
                              <cal-picker
                                v-model="nonTradeForm.transactionDate"
                                :label="nonTradeLabel.transactionDate"
                                :data-vv-as="nonTradeLabel.transactionDate"
                                data-vv-name="nonTradeForm.transactionDate"
                                :error-messages="errors.collect('nonTradeForm.transactionDate')"
                                v-validate="'required'"
                                :min="this.parseDateISO(this.tDateRange.effDate)"
                                :max="this.parseDateISO(this.tDateRange.expDate)"
                                @change="checkCurrRate"
                              ></cal-picker>
                            </v-flex>
                            <v-flex md3 xs12>
                              <v-autocomplete
                                :items="banks"
                                v-model="nonTradeForm.bankNo"
                                item-text="label"
                                item-value="value"
                                :label="nonTradeLabel.bankNo"
                                :error-messages="errors.collect('nonTradeForm.bankNo')"
                                data-vv-name="nonTradeForm.bankNo"
                                :data-vv-as="nonTradeLabel.bankNo"
                                v-validate="'required'"
                                @change="getBankInfo($event)"
                                clearable
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showBankNoHelpList = true">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md2 xs12>
                              <v-checkbox
                                color="primary"
                                :label="nonTradeLabel.docAE"
                                v-model="nonTradeForm.docAE"
                                @change="doDocAe($event)"
                                :disabled="this.nonTradeData.tranMode === 'R'"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md3 xs12>
                              <v-text-field
                                v-model="nonTradeForm.documentNo"
                                :disabled="isDisabledDocNo || this.nonTradeData.tranMode === 'R'"
                                :label="nonTradeLabel.documentNo"
                                :error-messages="errors.collect('nonTradeForm.documentNo')"
                                data-vv-name="nonTradeForm.documentNo"
                                :data-vv-as="nonTradeLabel.documentNo"
                                @blur="checkDocNo"
                                v-validate="docNoValidation"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md2 xs12>
                              <v-autocomplete
                                :items="funds"
                                v-model="nonTradeForm.fund"
                                :label="nonTradeLabel.fund"
                                disabled
                                item-text="label"
                                item-value="value"
                                data-vv-name="nonTradeForm.fund"
                                :data-vv-as="nonTradeLabel.fund"
                                :error-messages="errors.collect('nonTradeForm.fund')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md5 xs12>
                              <v-autocomplete
                                :items="acctnosuffixes"
                                v-model="nonTradeForm.accountNoSuffix"
                                item-text="label"
                                item-value="value"
                                :label="nonTradeLabel.accountNoSuffix"
                                :error-messages="errors.collect('nonTradeForm.accountNoSuffix')"
                                data-vv-name="nonTradeForm.accountNoSuffix"
                                :data-vv-as="nonTradeLabel.accountNoSuffix"
                                v-validate="'entry|max:60'"
                                clearable
                                :disabled="this.nonTradeData.tranMode === 'R'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon
                                    color="info"
                                    @click="showAcctSufHelpList = true"
                                    :disabled="this.nonTradeData.tranMode === 'R'"
                                  >mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md5 xs12>
                              <v-autocomplete
                                :items="paymentmethods"
                                v-model="nonTradeForm.paymentMethod"
                                :label="nonTradeLabel.paymentMethod"
                                item-text="label"
                                item-value="value"
                                data-vv-name="nonTradeForm.paymentMethod"
                                :data-vv-as="nonTradeLabel.paymentMethod"
                                v-validate="valRcptRequired"
                                :error-messages="errors.collect('nonTradeForm.paymentMethod')"
                                :disabled="nonTradeForm.transactionType === 'Z'"
                                @change="getPaymentMethod($event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="gstIO"
                                v-model="nonTradeForm.gstIO"
                                :label="nonTradeLabel.gstIO"
                                item-text="label"
                                item-value="value"
                                data-vv-name="gstIO"
                                :data-vv-as="nonTradeLabel.gstIO"
                                :error-messages="errors.collect('gstIO')"
                                @change="changeGstIO($event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="gstStatuses"
                                v-model="nonTradeForm.gstStatus"
                                :label="nonTradeLabel.gstStatus"
                                item-text="label"
                                item-value="value"
                                data-vv-name="gstStatus"
                                :data-vv-as="nonTradeLabel.gstStatus"
                                :error-messages="errors.collect('gstStatus')"
                                @change="changeGstRate($event)"
                                :disabled="isBlankGSTIO"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="nonTradeForm.gstRate"
                                :label="nonTradeLabel.gstRate"
                                :disabled="nonTradeForm.gstAmountAE === true"
                                :error-messages="errors.collect('nonTradeForm.gstRate')"
                                data-vv-name="nonTradeForm.gstRate"
                                :data-vv-as="nonTradeLabel.gstRate"
                                v-num-mask="{ negative: true, intScale: 5, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:99999.99'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md10 xs12>
                              <v-text-field
                                v-model="nonTradeForm.name"
                                :label="nonTradeLabel.name"
                                :error-messages="errors.collect('nonTradeForm.name')"
                                data-vv-name="nonTradeForm.name"
                                :data-vv-as="nonTradeLabel.name"
                                v-validate="'required|max:100|sanction:' + sanctionName1Error"
                                @change="valSanction(nonTradeForm.name, '', 'sanctionName1Error')"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md2 xs12>
                              <v-layout>
                                <v-flex md3 xs12>
                                  <v-subheader class="queryGreenLabel">{{ nonTradeLabel.insured }}</v-subheader>
                                </v-flex>
                                <v-flex md2 xs12>
                                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                    <v-icon color="info" @click="doInsuredHelpList('insured1')">mdi-magnify</v-icon>
                                  </v-slide-x-reverse-transition>
                                </v-flex>
                                <v-flex md5 xs12>
                                  <v-subheader class="queryRedLabel">{{ nonTradeLabel.intermediary }}</v-subheader>
                                </v-flex>
                                <v-flex md2 xs12>
                                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                    <v-icon color="info" @click="showInterHelpList = true">mdi-magnify</v-icon>
                                  </v-slide-x-reverse-transition>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="nonTradeForm.addr1"
                                :label="nonTradeLabel.addr1"
                                :error-messages="errors.collect('nonTradeForm.addr1')"
                                data-vv-name="nonTradeForm.addr1"
                                :data-vv-as="nonTradeLabel.addr1"
                                v-validate="'required|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="nonTradeForm.addr2"
                                :label="nonTradeLabel.addr2"
                                :error-messages="errors.collect('nonTradeForm.addr2')"
                                data-vv-name="nonTradeForm.addr2"
                                :data-vv-as="nonTradeLabel.addr2"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="nonTradeForm.addr3"
                                :label="nonTradeLabel.addr3"
                                :error-messages="errors.collect('nonTradeForm.addr3')"
                                data-vv-name="nonTradeForm.addr3"
                                :data-vv-as="nonTradeLabel.addr3"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="nonTradeForm.addr4"
                                :label="nonTradeLabel.addr4"
                                :error-messages="errors.collect('nonTradeForm.addr4')"
                                data-vv-name="nonTradeForm.addr4"
                                :data-vv-as="nonTradeLabel.addr4"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="nonTradeForm.postalCode"
                                :label="nonTradeLabel.postalCode"
                                :error-messages="errors.collect('nonTradeForm.postalCode')"
                                data-vv-name="nonTradeForm.postalCode"
                                :data-vv-as="nonTradeLabel.postalCode"
                                v-validate="'numeric|max:8'"
                                @change="checkAddress"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="printDocOpts"
                                v-model="nonTradeForm.printDocument"
                                :label="nonTradeLabel.printDocument"
                                item-text="label"
                                item-value="value"
                                data-vv-name="nonTradeForm.printDocument"
                                :data-vv-as="nonTradeLabel.printDocument"
                                :error-messages="errors.collect('nonTradeForm.printDocument')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="amountcurrencies"
                                v-model="nonTradeForm.amountCurr"
                                :label="nonTradeLabel.amountCurr"
                                item-text="label"
                                item-value="value"
                                :error-messages="errors.collect('nonTradeForm.amountCurr')"
                                data-vv-name="nonTradeForm.amountCurr"
                                :data-vv-as="nonTradeLabel.amountCurr"
                                v-validate="'required'"
                                clearable
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showCurrencyHelpList = true">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="amount"
                                v-model="nonTradeForm.amount"
                                :label="nonTradeLabel.amount"
                                :error-messages="errors.collect('nonTradeForm.amount')"
                                data-vv-name="nonTradeForm.amount"
                                :data-vv-as="nonTradeLabel.amount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'required|mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.01'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="nonTradeForm.gstAmountCurr"
                                :label="nonTradeLabel.gstAmountCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="nonTradeForm.gstAmountCurr"
                                :data-vv-as="nonTradeLabel.gstAmountCurr"
                                :error-messages="errors.collect('nonTradeForm.gstAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="nonTradeLabel.gstAmountAE"
                                :disabled="isGstAmtAE"
                                v-model="nonTradeForm.gstAmountAE"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="gstAmount"
                                v-model="nonTradeForm.gstAmount"
                                :label="nonTradeLabel.gstAmount"
                                :disabled="isGstAmt"
                                :error-messages="errors.collect('nonTradeForm.gstAmount')"
                                data-vv-name="nonTradeForm.gstAmount"
                                :data-vv-as="nonTradeLabel.gstAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.00'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="nonTradeForm.netAmountCurr"
                                :label="nonTradeLabel.netAmountCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="nonTradeForm.netAmountCurr"
                                :data-vv-as="nonTradeLabel.netAmountCurr"
                                :error-messages="errors.collect('nonTradeForm.netAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                v-model="nonTradeForm.netAmount"
                                :label="nonTradeLabel.netAmount"
                                :disabled="true"
                                :error-messages="errors.collect('nonTradeForm.netAmount')"
                                data-vv-name="nonTradeForm.netAmount"
                                :data-vv-as="nonTradeLabel.netAmount"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="nonTradeForm.bankAmountCurr"
                                :label="nonTradeLabel.bankAmountCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="nonTradeForm.bankAmountCurr"
                                :data-vv-as="nonTradeLabel.bankAmountCurr"
                                :error-messages="errors.collect('nonTradeForm.bankAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="nonTradeLabel.bankAmountAE"
                                v-model="nonTradeForm.bankAmountAE"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="bankAmount"
                                v-model="nonTradeForm.bankAmount"
                                :label="nonTradeLabel.bankAmount"
                                :disabled="isBankAmt"
                                :error-messages="errors.collect('nonTradeForm.bankAmount')"
                                data-vv-name="nonTradeForm.bankAmount"
                                :data-vv-as="nonTradeLabel.bankAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.00'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="nonTradeForm.bankChargesCurr"
                                :label="nonTradeLabel.bankChargesCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="nonTradeForm.bankChargesCurr"
                                :data-vv-as="nonTradeLabel.bankChargesCurr"
                                :error-messages="errors.collect('nonTradeForm.bankChargesCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="bankCharges"
                                v-model="nonTradeForm.bankCharges"
                                :label="nonTradeLabel.bankCharges"
                                :error-messages="errors.collect('nonTradeForm.bankCharges')"
                                data-vv-name="nonTradeForm.bankCharges"
                                :data-vv-as="nonTradeLabel.bankCharges"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="nonTradeForm.bankTotalAmountCurr"
                                :label="nonTradeLabel.bankTotalAmountCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="nonTradeForm.bankTotalAmountCurr"
                                :data-vv-as="nonTradeLabel.bankTotalAmountCurr"
                                :error-messages="errors.collect('nonTradeForm.bankTotalAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="bankTotalAmount"
                                v-model="nonTradeForm.bankTotalAmount"
                                :label="nonTradeLabel.bankTotalAmount"
                                disabled
                                :error-messages="errors.collect('nonTradeForm.bankTotalAmount')"
                                data-vv-name="nonTradeForm.bankTotalAmount"
                                :data-vv-as="nonTradeLabel.bankTotalAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="nonTradeLabel.bankTotalLocalAE"
                                v-model="nonTradeForm.bankTotalLocalAE"
                                :disabled="isEqualAmtCurr"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="bankTotalLocal"
                                v-model="nonTradeForm.bankTotalLocal"
                                :label="nonTradeLabel.bankTotalLocal"
                                :disabled="isBankTotLoc"
                                :error-messages="errors.collect('nonTradeForm.bankTotalLocal')"
                                data-vv-name="nonTradeForm.bankTotalLocal"
                                :data-vv-as="nonTradeLabel.bankTotalLocal"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.00'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="nonTradeForm.chequeNo"
                                :label="nonTradeLabel.chequeNo"
                                :error-messages="errors.collect('nonTradeForm.chequeNo')"
                                data-vv-name="nonTradeForm.chequeNo"
                                :data-vv-as="nonTradeLabel.chequeNo"
                                v-validate="chequeNoValidation"
                                :disabled="nonTradeForm.transactionType === 'Y'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-checkbox
                                color="primary"
                                :label="nonTradeLabel.prtCheque"
                                v-model="nonTradeForm.prtCheque"
                                :disabled="nonTradeForm.transactionType === 'Y'"
                              ></v-checkbox>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional" eager>
                <form data-vv-scope="OptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="nonTradeForm.policyNo"
                                :label="nonTradeLabel.policyNo"
                                :error-messages="errors.collect('nonTradeForm.policyNo')"
                                data-vv-name="nonTradeForm.policyNo"
                                :data-vv-as="nonTradeLabel.policyNo"
                                v-validate="'entry|max:60'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showPolicyHelpList = true">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="nonTradeForm.claimNo"
                                :label="nonTradeLabel.claimNo"
                                :error-messages="errors.collect('nonTradeForm.claimNo')"
                                data-vv-name="nonTradeForm.claimNo"
                                :data-vv-as="nonTradeLabel.claimNo"
                                v-validate="'entry|max:60'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showClaimHelpList = true">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="nonTradeForm.details"
                                :label="nonTradeLabel.details"
                                :error-messages="errors.collect('nonTradeForm.details')"
                                data-vv-name="nonTradeForm.details"
                                :data-vv-as="nonTradeLabel.details"
                                v-validate="'entry|max:120'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="nonTradeForm.statement"
                                :label="nonTradeLabel.statement"
                                :error-messages="errors.collect('nonTradeForm.statement')"
                                data-vv-name="nonTradeForm.statement"
                                :data-vv-as="nonTradeLabel.statement"
                                v-validate="'entry|max:120'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="nonTradeForm.insuredName"
                                :label="nonTradeLabel.insuredName"
                                :error-messages="errors.collect('nonTradeForm.insuredName')"
                                data-vv-name="nonTradeForm.insuredName"
                                :data-vv-as="nonTradeLabel.insuredName"
                                v-validate="'entry|max:100'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="doInsuredHelpList('insured2')">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="departments"
                                v-model="nonTradeForm.department"
                                :label="nonTradeLabel.department"
                                item-text="label"
                                item-value="value"
                                data-vv-name="nonTradeForm.department"
                                :data-vv-as="nonTradeLabel.department"
                                :error-messages="errors.collect('nonTradeForm.department')"
                                v-validate="deptValidation"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="nonTradeForm.gstRegNo"
                                :label="nonTradeLabel.gstRegNo"
                                :error-messages="errors.collect('nonTradeForm.gstRegNo')"
                                data-vv-name="nonTradeForm.gstRegNo"
                                :data-vv-as="nonTradeLabel.gstRegNo"
                                v-validate="'entry|max:20'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="nonTradeForm.taxInvoiceNo"
                                :label="nonTradeLabel.taxInvoiceNo"
                                :error-messages="errors.collect('nonTradeForm.taxInvoiceNo')"
                                data-vv-name="nonTradeForm.taxInvoiceNo"
                                :data-vv-as="nonTradeLabel.taxInvoiceNo"
                                v-validate="'entry|max:30'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="paymentmethod" eager>
                <form data-vv-scope="PaymentMethodForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="payerbanks"
                                :disabled="isPayBank"
                                v-model="nonTradeForm.payerBank"
                                :label="nonTradeLabel.payerBank"
                                item-text="label"
                                item-value="value"
                                data-vv-name="nonTradeForm.payerBank"
                                :data-vv-as="nonTradeLabel.payerBank"
                                :error-messages="errors.collect('nonTradeForm.payerBank')"
                                v-validate="payerBankValidate"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="nonTradeForm.payersChequeNo"
                                :disabled="isChequeNo"
                                :label="nonTradeLabel.payersChequeNo"
                                :error-messages="errors.collect('nonTradeForm.payersChequeNo')"
                                data-vv-name="nonTradeForm.payersChequeNo"
                                :data-vv-as="nonTradeLabel.payersChequeNo"
                                :maxlength="10"
                                v-validate="payChqNoValidate"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="nonTradeForm.drawerName"
                                :disabled="isDrawerName"
                                :label="nonTradeLabel.drawerName"
                                :error-messages="errors.collect('nonTradeForm.drawerName')"
                                data-vv-name="nonTradeForm.drawerName"
                                :data-vv-as="nonTradeLabel.drawerName"
                                :maxlength="50"
                                v-validate="drawerNameValidate"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                v-model="nonTradeForm.creditCardNo"
                                :disabled="isCreditCardNo"
                                :label="nonTradeLabel.creditCardNo"
                                :error-messages="errors.collect('nonTradeForm.creditCardNo')"
                                data-vv-name="nonTradeForm.creditCardNo"
                                :data-vv-as="nonTradeLabel.creditCardNo"
                                :maxlength="20"
                                v-validate="creditCardNoValidate"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>
            <v-card-actions>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
              <v-btn color="info" dark @click.prevent="doSave('CREATE_SAVE_REVIEW')" :loading="submitting">
                {{ actionLabel.saveAndReview }}
                <v-icon dark right>mdi-content-save</v-icon>
              </v-btn>
              <v-btn color="primary" dark @click.prevent="doSave('CREATE_SAVE_POST')" :loading="submitting">
                {{ actionLabel.saveAndPost }}
                <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog v-model="showBankNoHelpList" width="1280px">
        <bank-help-list @close="showBankNoHelpList = false" @assign-bank-info="assignBankInfo" :objData="bankHelpListScreen"></bank-help-list>
      </v-dialog>

      <v-dialog v-model="showAcctSufHelpList" width="1280px">
        <acct-suf-help-list @close="showAcctSufHelpList = false" @assign-acct-suf-info="assignAcctSufInfo"></acct-suf-help-list>
      </v-dialog>

      <v-dialog v-model="showInsuredHelpList" width="1280px">
        <insured-help-list
          @close="showInsuredHelpList = false"
          headerInfo="header2"
          :insuredFieldKey="insuredField"
          @assign-insured-info="assignInsuredInfo"
        ></insured-help-list>
      </v-dialog>

      <v-dialog v-model="showInterHelpList" width="1280px">
        <intermediary-help-list
          @close="showInterHelpList = false"
          headerInfo="header2"
          @assign-intermediary-data="assignInterInfo"
        ></intermediary-help-list>
      </v-dialog>

      <v-dialog v-model="showCurrencyHelpList" width="1280px">
        <currency-help-list @close="showCurrencyHelpList = false" @assign-currency-info="assignCurrencyInfo"></currency-help-list>
      </v-dialog>

      <v-dialog v-model="showPolicyHelpList" width="1280px">
        <policy-help-list2 @close="showPolicyHelpList = false" @assign-policy-info="assignPolicyInfo"></policy-help-list2>
      </v-dialog>

      <v-dialog v-model="showClaimHelpList" width="1280px">
        <claim-help-list @close="showClaimHelpList = false" @assign-claim-info="assignClaimInfo"></claim-help-list>
      </v-dialog>

      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loadingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Loading...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when creating payment.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--LYT Added: 2020-08-27  Sanction Partial Matched Names List -->
      <v-dialog v-model="showSanctionDialog" width="1280px">
        <sanction-partial-match-list :sanctionItems="sanctionPartialMatchItems" @close="showSanctionDialog = false"></sanction-partial-match-list>
      </v-dialog>
      <prompt-leave
        v-if="showPromptLeave"
        title="NonTrade"
        :tranMode="this.nonTradeData.tranMode"
        v-model="promptLeave"
        @exit="doExit"
        @saveAndExit="doSaveAndExit"
      ></prompt-leave>

      <confirm v-model="promptConfirmation" @ok="doProceed" @cancel="processingFlag = false">
        <p>Cheque No. is existing in other payment, do you want to proceed?</p>
        <div class="queryValue">
          Bank No. : {{ this.chequeForm.bankNo }}<br />
          Cheque No. : {{ this.chequeForm.chequeNo }}<br />
        </div>
      </confirm>
      <confirm v-model="promptUpdateInsDet" @ok="doPomptFilterBrowser">
        {{ promptWarnMsg }}
      </confirm>
    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { nonTradeViewMixin } from '@/mixins/accounting/nonTrade/nonTradeViewMixin'
import { nonTradeAjaxMixin } from '@/mixins/accounting/nonTrade/nonTradeAjaxMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import BankHelpList from '@/components/core/common/dialog/BankHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'
import InsuredHelpList from '@/components/core/common/dialog/InsuredHelpList'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import PolicyHelpList2 from '@/components/core/common/dialog/PolicyHelpList2'
import ClaimHelpList from '@/components/core/common/dialog/ClaimHelpList'
import { paymentAjaxMixin } from '@/mixins/accounting/payment/paymentAjaxMixin'
import { receiptsAjaxMixin } from '@/mixins/accounting/receipts/receiptsAjaxMixin'
import { parseISO } from 'date-fns'
import { promptOnExitMixin } from '@/mixins/common/promptOnExitMixin'
import PromptLeave from '@/components/core/common/prompt/PromptLeave'
import { formatPrice } from '@/utils/index'
import { formatDisplayDateTime2 } from '@/utils/date'
import { removeFormatNumber } from '@/utils/number'
import SanctionPartialMatchList from '@/components/core/common/dialog/SanctionPartialMatchList'

export default {
  data() {
    return {
      actionLabel: {
        cancel: 'Cancel',
        saveAndReview: 'Save & Review',
        saveAndPost: 'Save & Post'
      },
      actionName: null,
      tabNav: 0,
      loading: false,
      loadingFlag: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      showPromptLeave: true,
      branches: [],
      trandaterange: {},
      banks: [],
      acctnosuffixes: [],
      paymentmethods: [],
      funds: [],
      showBankNoHelpList: false,
      showAcctSufHelpList: false,
      showInsuredHelpList: false,
      showInterHelpList: false,
      showCurrencyHelpList: false,
      showPolicyHelpList: false,
      showClaimHelpList: false,
      valRcptRequired: '',
      valPaytRequired: '',
      gstStatuses: [],
      miscacctparams: [],
      chequeNoForm: null,
      currencies: [],
      promptConfirmation: false,
      isExistChequeNo: false,
      amountcurrencies: [],
      isMandatory: true,
      isOptional: false,
      departments: [],
      isPaymentMethod: false,
      validStatus: {
        mandatory: true,
        optional: true,
        paymentMethod: true
      },
      insuredField: '',
      payerbanks: [],
      paymentmethod: {},
      chequeForm: {
        bankNo: null,
        chequeNo: null
      },
      existDocNo: null,
      promptUpdateInsDet: false,
      promptWarnMsg: 'Do you need to proceed to update insured Name and department?',
      insuredDet: {
        insdName: null,
        department: null,
        insdRefNo: null
      },
      isEqualAmtCurr: false
    }
  },
  methods: {
    async doInit() {
      this.loadingFlag = true
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('nonTradeInit')])
      await Promise.all([this.$store.dispatch('receiptInit')])
      await Promise.all([this.$store.dispatch('paymentInit')])
      this.bankHelpListScreen = 'screen_1'
      this.fetchBranch()
      this.fetchBank()
      this.fetchAcctNoSfx()
      this.fetchGstStatus()
      this.fetchAmountCurrency()
      this.fetchCurrency()
      this.fetchDepartment()
      this.fetchFund()
      this.getBaseCurr(this.nonTradeForm)
      if (this.nonTradeData.tranMode === 'R') {
        await Promise.all([this.performNonTradeReview()])
      }
      await this.doSelectTranType()
    },
    async doSelectTranType() {
      this.resetMessages()
      this.resetValidator()
      if (this.nonTradeForm.transactionType === 'Y') {
        if (this.nonTradeData.tranMode !== 'R') {
          this.nonTradeForm.transactionDate = new Date()
          this.nonTradeForm.gstIO = 'B'
          this.nonTradeForm.gstStatus = 'N'
          this.nonTradeForm.branch = this.token.userBranch
          this.getDefaultBankNo(this.token.userBranch, this.nonTradeForm, 'receipt').then((result) => {
            if (result) {
              this.getPaymentMethod(this.nonTradeForm.paymentMethod)
              this.checkTotAmtCurrCompanyCurr()
            }
          })
          this.getCommonData('miscacctparams').then(() => {
            this.nonTradeForm.printDocument = this.miscacctparams.defIlnrcpt
          })
        }
        this.getCommonData('trandaterange', '003')
        this.fetchPaymentMethod()
        this.fetchPayerBank()
        this.valRcptRequired = 'required'
        this.valPaytRequired = ''
      } else {
        if (this.nonTradeData.tranMode !== 'R') {
          this.nonTradeForm.transactionDate = new Date()
          this.nonTradeForm.branch = this.token.userBranch
          this.nonTradeForm.gstIO = 'B'
          this.nonTradeForm.gstStatus = 'N'
          this.nonTradeForm.paymentMethod = ''
          this.nonTradeForm.payerBank = ''
          this.nonTradeForm.payersChequeNo = ''
          this.nonTradeForm.drawerName = ''
          this.nonTradeForm.creditCardNo = ''
          this.getDefaultBankNo(this.token.userBranch, this.nonTradeForm, 'payment').then((result) => {
            if (result) {
              this.checkTotAmtCurrCompanyCurr()
            }
          })
          this.getCommonData('miscacctparams').then(() => {
            this.nonTradeForm.printDocument = this.miscacctparams.defIlnpv
          })
        }
        this.getChequeNoForm()
        this.getCommonData('trandaterange', '004')
        this.valRcptRequired = ''
        this.valPaytRequired = 'required'
      }
      this.loadingFlag = false
    },
    doGetDefaultBankNo() {
      let tranType
      if (this.nonTradeForm.transactionType === 'Y') {
        tranType = 'receipt'
      } else {
        tranType = 'payment'
      }
      this.getDefaultBankNo(this.nonTradeForm.branch, this.nonTradeForm, tranType)
      this.checkTotAmtCurrCompanyCurr()
    },
    doRcptPayt(data) {
      this.doSelectTranType()
    },
    changeGstIO(gstIO) {
      this.nonTradeForm.gstIO = gstIO
      if (this.nonTradeForm.gstIO === 'B') {
        this.nonTradeForm.gstStatus = 'N'
        this.nonTradeForm.gstAmount = (0.0).toFixed(2)
        this.nonTradeForm.gstRate = (0.0).toFixed(2)
      } else {
        this.nonTradeForm.gstStatus = 'M'
        this.getCommonData('gstrate', this.nonTradeForm.gstStatus, formatDisplayDateTime2(this.nonTradeForm.transactionDate))
      }
      this.calculateAmount()
    },
    assignGSTRate(data) {
      this.nonTradeForm.gstRate = formatPrice(data)
      this.calculateAmount()
    },
    changeGstRate(gstStatus) {
      this.getCommonData('gstrate', gstStatus, formatDisplayDateTime2(this.nonTradeForm.transactionDate))
    },
    assignBankInfo(data) {
      this.nonTradeForm.bankNo = data.defPayBank
      this.nonTradeForm.fund = data.bankFund
      this.nonTradeForm.amountCurr = data.bankAcctCurrency
      this.nonTradeForm.amountCurrRate = data.bankCurrRate
      this.nonTradeForm.gstAmountCurr = data.bankAcctCurrency
      this.nonTradeForm.netAmountCurr = data.bankAcctCurrency
      this.nonTradeForm.bankAmountCurr = data.bankAcctCurrency
      this.nonTradeForm.bankAmountCurrRate = data.bankCurrRate
      this.nonTradeForm.bankChargesCurr = data.bankAcctCurrency
      this.nonTradeForm.bankTotalAmountCurr = data.bankAcctCurrency
      this.showBankNoHelpList = false
      this.checkTotAmtCurrCompanyCurr()
      this.calculateAmount()
      if (this.nonTradeForm.transactionType === 'Y') {
        this.nonTradeForm.paymentMethod = data.bankPaymentMethod
        this.getPaymentMethod(data.bankPaymentMethod)
      }
    },
    assignAcctSufInfo(data) {
      this.nonTradeForm.accountNoSuffix = data.acctNoSfx
      this.showAcctSufHelpList = false
    },
    checkTotAmtCurrCompanyCurr() {
      if (this.nonTradeForm.netAmountCurr === this.nonTradeForm.bankTotalLocalCurr) {
        this.nonTradeForm.bankTotalLocalAE = true
        this.isEqualAmtCurr = true
      } else {
        this.isEqualAmtCurr = false
      }
    },
    assignInsuredInfo(data) {
      if (data.insuredFieldKey === 'insured1') {
        this.nonTradeForm.name = data.name1
        this.nonTradeForm.addr1 = data.address1
        this.nonTradeForm.addr2 = data.address2
        this.nonTradeForm.addr3 = data.address3
        this.nonTradeForm.addr4 = data.address4
        this.nonTradeForm.postalCode = data.postalCode
      } else if (data.insuredFieldKey === 'insured2') {
        this.nonTradeForm.insuredName = data.name1
      }
      this.showInsuredHelpList = false
    },
    assignInterInfo(data) {
      this.nonTradeForm.name = data.name
      this.nonTradeForm.addr1 = data.address1
      this.nonTradeForm.addr2 = data.address2
      this.nonTradeForm.addr3 = data.address3
      this.nonTradeForm.addr4 = data.address4
      this.nonTradeForm.postalCode = data.postalCode
      this.showInterHelpList = false
    },
    assignCurrencyInfo(data) {
      this.nonTradeForm.amountCurr = data.curr
      this.nonTradeForm.gstAmountCurr = data.curr
      this.nonTradeForm.netAmountCurr = data.curr
      this.nonTradeForm.amountCurrRate = data.currRate
      this.showCurrencyHelpList = false

      this.calculateAmount()
    },
    assignCurrRate(currRate) {
      this.nonTradeForm.amountCurrRate = currRate
      this.nonTradeForm.gstAmountCurr = this.nonTradeForm.amountCurr
      this.nonTradeForm.netAmountCurr = this.nonTradeForm.amountCurr
      this.calculateAmount()
    },
    assignBankCurrRate(data) {
      this.nonTradeForm.bankAmountCurrRate = data.bankCurrRate
      this.calculateAmount()
    },
    async getBankInfo(bankNo) {
      this.getCommonData('bankdata', bankNo, formatDisplayDateTime2(this.nonTradeForm.transactionDate))
    },
    doPomptFilterBrowser() {
      this.nonTradeForm.insuredName = this.insuredDet.insdName
      this.nonTradeForm.department = this.insuredDet.department
      this.nonTradeForm.insdRefNo = this.insuredDet.insdRefNo
    },
    assignPolicyInfo(data) {
      this.nonTradeForm.policyNo = data.polNo + '-' + data.renCnt + '-' + data.endtCnt
      this.insuredDet.insdName = data.insdName1
      this.insuredDet.department = data.dept
      this.insuredDet.insdRefNo = data.insdRefNo
      this.showPolicyHelpList = false
      if (
        (this.nonTradeForm.insuredName === null || this.nonTradeForm.insuredName === '') &&
        (this.nonTradeForm.department === null || this.nonTradeForm.department === '')
      ) {
        this.nonTradeForm.insuredName = data.insdName1
        this.nonTradeForm.department = data.dept
        this.nonTradeForm.insdRefNo = data.insdRefNo
      } else {
        this.promptUpdateInsDet = true
      }
    },
    assignClaimInfo(data) {
      this.nonTradeForm.claimNo = data.clmNo
      this.insuredDet.insdName = data.insdName1
      this.insuredDet.department = data.dept
      this.insuredDet.insdRefNo = data.insdRefNo
      this.showClaimHelpList = false
      if (
        (this.nonTradeForm.insuredName === null || this.nonTradeForm.insuredName === '') &&
        (this.nonTradeForm.department === null || this.nonTradeForm.department === '')
      ) {
        this.nonTradeForm.insuredName = data.insdName1
        this.nonTradeForm.department = data.dept
        this.nonTradeForm.insdRefNo = data.insdRefNo
      } else {
        this.promptUpdateInsDet = true
      }
    },
    async getPaymentMethod(payment) {
      this.getCommonData('paymentmethod', payment)
    },
    checkDocNo() {
      this.isDocNoExist(this.nonTradeForm).then((result) => {
        if (this.nonTradeForm.isExistDocNo === 'true') {
          this.existDocNo = this.nonTradeForm.documentNo
        }
      })
    },
    checkCurrRate() {
      if (this.nonTradeForm.amountCurr && this.nonTradeForm.transactionDate) {
        this.getCommonData('currencyrate', this.nonTradeForm.amountCurr, formatDisplayDateTime2(this.nonTradeForm.transactionDate))
        this.getCommonData('bankcurrencyrate', this.nonTradeForm.bankNo, formatDisplayDateTime2(this.nonTradeForm.transactionDate))
      }
    },
    doInsuredHelpList(field) {
      this.insuredField = field
      this.showInsuredHelpList = true
    },
    calculateAmount() {
      let bankAmt = 0.0
      let bankTotAmt = 0.0
      if (this.nonTradeForm.gstAmountAE) {
        this.nonTradeForm.gstAmount = formatPrice((removeFormatNumber(this.nonTradeForm.amount) * this.nonTradeForm.gstRate) / 100)
      }
      if (this.nonTradeForm.gstIO === 'B') {
        this.nonTradeForm.netAmount = formatPrice(Number(removeFormatNumber(this.nonTradeForm.amount)))
      }
      if (this.nonTradeForm.transactionType === 'Z') {
        if (this.nonTradeForm.gstIO === 'I') {
          this.nonTradeForm.netAmount = formatPrice(
            Number(removeFormatNumber(this.nonTradeForm.amount)) + Number(removeFormatNumber(this.nonTradeForm.gstAmount))
          )
        } else if (this.nonTradeForm.gstIO === 'O') {
          this.nonTradeForm.netAmount = formatPrice(
            Number(removeFormatNumber(this.nonTradeForm.amount)) - Number(removeFormatNumber(this.nonTradeForm.gstAmount))
          )
        }
      } else {
        if (this.nonTradeForm.gstIO === 'I') {
          this.nonTradeForm.netAmount = formatPrice(
            removeFormatNumber(this.nonTradeForm.amount) - Number(removeFormatNumber(this.nonTradeForm.gstAmount))
          )
        }
        if (this.nonTradeForm.gstIO === 'O') {
          this.nonTradeForm.netAmount = formatPrice(
            Number(removeFormatNumber(this.nonTradeForm.amount)) + Number(removeFormatNumber(this.nonTradeForm.gstAmount))
          )
        }
      }

      if (this.nonTradeForm.bankAmountAE) {
        this.nonTradeForm.bankAmount = formatPrice(
          (removeFormatNumber(this.nonTradeForm.netAmount) * this.nonTradeForm.amountCurrRate) / this.nonTradeForm.bankAmountCurrRate
        )
      }

      if (this.nonTradeForm.transactionType === 'Z') {
        this.nonTradeForm.bankTotalAmount = formatPrice(
          Number(removeFormatNumber(this.nonTradeForm.bankAmount)) + Number(removeFormatNumber(this.nonTradeForm.bankCharges))
        )
        if (this.nonTradeForm.bankTotalLocalAE) {
          if (this.nonTradeForm.bankAmountAE) {
            bankAmt =
              (Number(removeFormatNumber(this.nonTradeForm.netAmount)) * Number(removeFormatNumber(this.nonTradeForm.amountCurrRate))) /
              Number(removeFormatNumber(this.nonTradeForm.bankAmountCurrRate))
          } else {
            bankAmt = removeFormatNumber(this.nonTradeForm.bankAmount)
          }
          bankTotAmt = Number(bankAmt) + Number(removeFormatNumber(this.nonTradeForm.bankCharges))
          bankTotAmt = bankTotAmt * Number(this.nonTradeForm.bankAmountCurrRate)
          this.nonTradeForm.bankTotalLocal = formatPrice(bankTotAmt)
        }
      } else {
        this.nonTradeForm.bankTotalAmount = formatPrice(
          removeFormatNumber(this.nonTradeForm.bankAmount) - removeFormatNumber(this.nonTradeForm.bankCharges)
        )
        if (this.nonTradeForm.bankTotalLocalAE) {
          if (this.nonTradeForm.bankAmountAE) {
            bankAmt =
              (Number(removeFormatNumber(this.nonTradeForm.netAmount)) * Number(removeFormatNumber(this.nonTradeForm.amountCurrRate))) /
              Number(removeFormatNumber(this.nonTradeForm.bankAmountCurrRate))
          } else {
            bankAmt = removeFormatNumber(this.nonTradeForm.bankAmount)
          }
          bankTotAmt = Number(bankAmt) - Number(removeFormatNumber(this.nonTradeForm.bankCharges))
          bankTotAmt = bankTotAmt * Number(this.nonTradeForm.bankAmountCurrRate)
          this.nonTradeForm.bankTotalLocal = formatPrice(bankTotAmt)
        }
      }
      this.setAmount()
    },
    setAmount() {
      this.$refs.amount.$el.cleave.setRawValue(this.nonTradeForm.amount)
      this.nonTradeForm.amount = formatPrice(this.$refs.amount.$el.cleave.getRawValue())
      this.$refs.gstAmount.$el.cleave.setRawValue(this.nonTradeForm.gstAmount)
      this.nonTradeForm.gstAmount = formatPrice(this.$refs.gstAmount.$el.cleave.getRawValue())
      this.$refs.bankAmount.$el.cleave.setRawValue(this.nonTradeForm.bankAmount)
      this.nonTradeForm.bankAmount = formatPrice(this.$refs.bankAmount.$el.cleave.getRawValue())
      this.$refs.bankCharges.$el.cleave.setRawValue(this.nonTradeForm.bankCharges)
      this.nonTradeForm.bankCharges = formatPrice(this.$refs.bankCharges.$el.cleave.getRawValue())
      this.$refs.bankTotalLocal.$el.cleave.setRawValue(this.nonTradeForm.bankTotalLocal)
      this.nonTradeForm.bankTotalLocal = formatPrice(this.$refs.bankTotalLocal.$el.cleave.getRawValue())
      this.$refs.bankTotalAmount.$el.cleave.setRawValue(this.nonTradeForm.bankTotalAmount)
      this.nonTradeForm.bankTotalAmount = formatPrice(this.$refs.bankTotalAmount.$el.cleave.getRawValue())
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    },
    doProceed() {
      this.promptConfirmation = false
      this.doSaveTransaction()
    },
    doDocAe(event) {
      this.nonTradeForm.documentNo = null
      this.resetMessages()
      this.resetValidator()
    },
    checkPaytChequeNo() {
      if (this.nonTradeForm.chequeNo !== null && this.nonTradeForm.chequeNo !== '') {
        const form = {
          chequeNo: this.nonTradeForm.chequeNo,
          fromBank: this.nonTradeForm.bankNo,
          branch: this.nonTradeForm.branch,
          transactionType: this.nonTradeForm.transactionType,
          documentNo: this.nonTradeForm.documentNo,
          accountNo: '',
          fund: this.nonTradeForm.fund,
          accountNoSuffix: this.nonTradeForm.accountNoSuffix
        }
        this.getAcctMasterPaytChequeNo(form).then((result) => {
          if (result) {
            if (this.isExistChequeNo === 'true') {
              this.chequeForm.bankNo = this.nonTradeForm.bankNo
              this.chequeForm.chequeNo = this.nonTradeForm.chequeNo
              this.isMandatory = true
              this.isOptional = false
              this.isPaymentMethod = false
              this.tabNav = 0
              this.promptConfirmation = true
            } else {
              this.doSaveTransaction()
            }
          }
        })
      } else {
        this.doSaveTransaction()
      }
    },
    checkRcptChequeNo() {
      if (this.nonTradeForm.payersChequeNo !== null && this.nonTradeForm.payersChequeNo !== '') {
        const form = {
          payersChequeNo: this.nonTradeForm.payersChequeNo,
          bankNo: this.nonTradeForm.bankNo,
          branch: this.nonTradeForm.branch,
          transactionType: this.nonTradeForm.transactionType,
          documentNo: this.nonTradeForm.documentNo,
          acctNo: '',
          fund: this.nonTradeForm.fund,
          accountNoSuffix: this.nonTradeForm.accountNoSuffix
        }
        this.getAcctMasterRcptChequeNo(form).then((result) => {
          if (result) {
            if (this.isExistChequeNo === 'true') {
              this.chequeForm.bankNo = this.nonTradeForm.bankNo
              this.chequeForm.chequeNo = this.nonTradeForm.payersChequeNo
              this.isMandatory = false
              this.isOptional = false
              this.isPaymentMethod = true
              this.tabNav = 2
              this.promptConfirmation = true
            } else {
              this.doSaveTransaction()
            }
          }
        })
      } else {
        this.doSaveTransaction()
      }
    },
    doCancel() {
      this.$router.push({ name: 'nonTrade' }).catch(() => {})
    },
    doSaveTransaction() {
      if (this.nonTradeData.tranMode === 'R') {
        if (this.actionName === 'CREATE_SAVE_REVIEW') {
          this.actionName = 'UPDATE_SAVE_REVIEW'
        } else if (this.actionName === 'CREATE_SAVE_POST') {
          this.actionName = 'UPDATE_SAVE_POST'
        }
      }
      this.nonTradeForm.actionName = this.actionName
      this.processingFlag = true
      this.performNonTradeSave()
    },
    doSave(actionName) {
      this.actionName = actionName
      let num = '003'
      if (this.nonTradeForm.transactionType === 'Z') {
        num = '004'
      }
      this.processingFlag = true
      this.$validator.validateAll('MainMandatoryForm').then((result) => {
        if (result) {
          this.ValidateTranDateRange(this.nonTradeForm.transactionDate, num).then((result12) => {
            if (result12) {
              this.$validator.validateAll('OptionalForm').then((result2) => {
                if (result2) {
                  if (this.nonTradeForm.transactionType === 'Y') {
                    this.$validator.validateAll('PaymentMethodForm').then((result3) => {
                      if (result3) {
                        this.checkRcptChequeNo()
                      } else {
                        this.isMandatory = false
                        this.isOptional = false
                        this.isPaymentMethod = true
                        this.processingFlag = false
                        this.tabNav = 2
                      }
                    })
                  } else {
                    this.checkPaytChequeNo()
                  }
                } else {
                  this.isMandatory = false
                  this.isOptional = true
                  this.isPaymentMethod = false
                  this.processingFlag = false
                  this.tabNav = 1
                }
              })
            } else {
              this.isMandatory = true
              this.isOptional = false
              this.isPaymentMethod = false
              this.processingFlag = false
              this.tabNav = 0
            }
          })
        } else {
          this.isMandatory = true
          this.isOptional = false
          this.isPaymentMethod = false
          this.processingFlag = false
          this.tabNav = 0
        }
      })
    },
    doValidateMandatory(tabId) {
      this.resetMessages()
      let num = '003'
      if (this.nonTradeForm.transactionType === 'Z') {
        num = '004'
      }
      if (this.isMandatory === true) {
        if (tabId === 2 && this.nonTradeForm.transactionType !== 'Y') {
          this.tabNav = 0
        } else {
          this.$validator.validateAll('MainMandatoryForm').then((result) => {
            if (result) {
              this.ValidateTranDateRange(this.nonTradeForm.transactionDate, num).then((result2) => {
                if (result2) {
                  if (tabId === 1) {
                    this.isMandatory = false
                    this.isOptional = true
                    this.isPaymentMethod = false
                  } else if (tabId === 2) {
                    this.$validator.validateAll('OptionalForm').then((result3) => {
                      if (result3) {
                        this.isMandatory = false
                        this.isOptional = false
                        this.isPaymentMethod = true
                      } else {
                        this.isMandatory = false
                        this.isOptional = true
                        this.isPaymentMethod = false
                        this.tabNav = 1
                      }
                    })
                  }
                  this.tabNav = tabId
                } else {
                  this.tabNav = 0
                }
              })
            } else {
              this.tabNav = 0
            }
          })
        }
      } else if (this.isOptional === true) {
        if (tabId === 2 && this.nonTradeForm.transactionType !== 'Y') {
          this.tabNav = 1
        } else {
          this.$validator.validateAll('OptionalForm').then((result) => {
            if (result) {
              if (tabId === 0) {
                this.isMandatory = true
                this.isOptional = false
                this.isPaymentMethod = false
              } else if (tabId === 2 && this.nonTradeForm.transactionType === 'Y') {
                this.isMandatory = false
                this.isOptional = false
                this.isPaymentMethod = true
              }
              this.tabNav = tabId
            } else {
              this.tabNav = 1
            }
          })
        }
      } else if (this.isPaymentMethod === true) {
        this.$validator.validateAll('PaymentMethodForm').then((result) => {
          if (result) {
            if (tabId === 0) {
              this.isMandatory = true
              this.isOptional = false
              this.isPaymentMethod = false
            } else if (tabId === 1) {
              this.isMandatory = false
              this.isOptional = true
              this.isPaymentMethod = false
            }
            this.tabNav = tabId
          } else {
            this.tabNav = 2
          }
        })
      }
    },
    checkAddress() {
      this.fetchAddress(this.nonTradeForm.postalCode)
    },
    assignAddress(data) {
      this.nonTradeForm.addr1 = data.add1
      this.nonTradeForm.addr3 = data.add2
      this.nonTradeForm.addr4 = data.add4
      this.nonTradeForm.postalCode = data.postalCode
    }
  },
  computed: {
    nonTradeData() {
      return this.$store.state.nonTrade.nonTradeData
    },
    tDateRange() {
      return this.trandaterange
    },
    displayErrorDialog() {
      return this.messages
    },
    isDisabledDocNo: function () {
      return this.nonTradeForm.docAE
    },
    token() {
      return this.$store.state.token
    },
    isGstAmtAE: function () {
      return this.nonTradeForm.gstIO === 'B'
    },
    isGstAmt: function () {
      return this.nonTradeForm.gstAmountAE
    },
    isBankAmt: function () {
      return this.nonTradeForm.bankAmountAE
    },
    isBankTotLoc: function () {
      if (this.isEqualAmtCurr) {
        return true
      } else {
        return this.nonTradeForm.bankTotalLocalAE
      }
    },
    isCreditCardNo: function () {
      return this.paymentmethod.crcdNo !== 'M' && this.paymentmethod.crcdNo !== 'O'
    },
    isDrawerName: function () {
      return this.paymentmethod.drawName !== 'M' && this.paymentmethod.drawName !== 'O'
    },
    isChequeNo: function () {
      return this.paymentmethod.payChqNo !== 'M' && this.paymentmethod.payChqNo !== 'O'
    },
    isPayBank: function () {
      return this.paymentmethod.payBank !== 'M' && this.paymentmethod.payBank !== 'O'
    },
    isCashBook: function () {
      return this.miscacctparams.cashBkMand === null || this.miscacctparams.cashBkMand === false
    },
    isBlankGSTIO: function () {
      return this.nonTradeForm.gstIO === 'B'
    },
    payChqNoValidate() {
      if (this.paymentmethod.payChqNo === 'M') {
        return 'required'
      } else {
        return ''
      }
    },
    payerBankValidate() {
      if (this.paymentmethod.payBank === 'M') {
        return 'required'
      } else {
        return ''
      }
    },
    drawerNameValidate() {
      if (this.paymentmethod.drawName === 'M') {
        return 'required'
      } else {
        return ''
      }
    },
    creditCardNoValidate() {
      if (this.paymentmethod.crcdNo === 'M') {
        return 'required'
      } else {
        return ''
      }
    },
    chequeNoValidation() {
      if (this.nonTradeForm.transactionType === 'Z') {
        if (parseInt(this.chequeNoForm) === 0) {
          return 'required|max:10'
        } else if (this.chequeNoForm > 0) {
          return 'entry|chequeNo:' + this.chequeNoForm
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    docNoValidation() {
      if (this.nonTradeForm.docAE === false && (this.nonTradeForm.documentNo === null || this.nonTradeForm.documentNo === '')) {
        return 'required'
      } else {
        return 'entry|documentNo:' + this.nonTradeForm.transactionType + ',' + this.existDocNo
      }
    },
    deptValidation() {
      if (this.miscacctparams.deptMand) {
        return 'required'
      } else {
        return ''
      }
    }
  },
  created() {
    this.$validator.extend('documentNo', {
      getMessage(field, args) {
        return 'Transaction type ' + args[0] + ' and Document No.' + args[1] + ' already present in AcctMaster'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var isdocNoExist = args[1]
        if (isdocNoExist === value) {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('chequeNo', {
      getMessage(field, args) {
        return 'This Cheque No. exceed Cheque No. Form'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var cheqNoForm = args[0]
        if (cheqNoForm > 0) {
          if (value.length > cheqNoForm) {
            return false
          } else {
            return true
          }
        }
      }
    })
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    'tDateRange.effDate': function () {
      if (this.tDateRange.effDate !== '') {
        this.getCommonData('gstrate', this.nonTradeForm.gstStatus, formatDisplayDateTime2(this.nonTradeForm.transactionDate))
      }
    },
    'nonTradeForm.amountCurr': function () {
      if (this.nonTradeForm.amountCurr && this.nonTradeForm.transactionDate) {
        this.getCommonData('currencyrate', this.nonTradeForm.amountCurr, formatDisplayDateTime2(this.nonTradeForm.transactionDate))
      }
    },
    'nonTradeForm.transactionDate': function () {
      if (this.nonTradeForm.amountCurr && this.nonTradeForm.transactionDate) {
        this.getCommonData('currencyrate', this.nonTradeForm.amountCurr, formatDisplayDateTime2(this.nonTradeForm.transactionDate))
        this.getCommonData('bankcurrencyrate', this.nonTradeForm.bankNo, formatDisplayDateTime2(this.nonTradeForm.transactionDate))
      }
    },
    payerBankValidate: {
      handler: function (isMandatory) {
        if (isMandatory) {
          this.nonTradeLabel.payerBank = 'Payer Bank*'
        } else {
          this.nonTradeLabel.payerBank = 'Payer Bank'
        }
      }
    },
    drawerNameValidate: {
      handler: function (isMandatory) {
        if (isMandatory) {
          this.nonTradeLabel.drawerName = 'Drawer Name*'
        } else {
          this.nonTradeLabel.drawerName = 'Drawer Name'
        }
      }
    },
    creditCardNoValidate: {
      handler: function (isMandatory) {
        if (isMandatory) {
          this.nonTradeLabel.creditCardNo = 'Credit Card No*'
        } else {
          this.nonTradeLabel.creditCardNo = 'Credit Card No'
        }
      }
    },
    departmentValidate: {
      handler: function (isMandatory) {
        if (isMandatory) {
          this.nonTradeLabel.department = 'Department*'
        } else {
          this.nonTradeLabel.department = 'Department'
        }
      }
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, commonAjaxMixin, nonTradeViewMixin, nonTradeAjaxMixin, paymentAjaxMixin, promptOnExitMixin, receiptsAjaxMixin],
  components: {
    BankHelpList,
    AcctSufHelpList,
    InsuredHelpList,
    IntermediaryHelpList,
    PolicyHelpList2,
    ClaimHelpList,
    PromptLeave,
    SanctionPartialMatchList
  }
}
</script>
